import React from 'react';
import { motion } from 'framer-motion';
export function PartnersSection() {
  const partners = [{
    name: 'Blue Cross Blue Shield',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/k9m7MMtvisTqPA36cgQ9v2/blue.png'
  }, {
    name: 'UnitedHealth Group',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/paJjubNonk4CASNx8n2fcf/UHG.png'
  }, {
    name: 'Harvard Medical School',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6ZqzfWKfrzdGSnC9QDF2K4/harvardmedical.png'
  }, {
    name: 'Yale University School of Medicine',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fEBXg2vQyfJMZcRCWHsxwQ/ylae.png'
  }, {
    name: 'Mass General Brigham',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kEpLwqHHGxp7vJdeLVCKm3/mgb.png'
  }, {
    name: 'Yale New Haven Health',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9vgnztQkop53iqFSJdaMb1/ynhhbig.png'
  }, {
    name: 'UCHealth',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bwj3hLygBEW8gzqykaAYDX/uchealth.png'
  }, {
    name: 'Methodist Health System',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nZbp48dFaqUpqA1zRoMyDv/methodist.png'
  }, {
    name: 'AltaMed',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wZBYz7idHx1EDScaGC9vks/altamed.png'
  }, {
    name: 'MultiCare',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZnYTg8FKAcM5oVBtUQVaz/multicare.png'
  }, {
    name: 'DART',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/m5VRedSTeiLWtoXdoPHgjP/dart.png'
  }, {
    name: 'Kaiser Permanente',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kMSM7LaV4wpQuSELUXNChg/kasier.png'
  }];
  return <section className="bg-black pb-8 pt-16" data-id="element-134">
      <div className="group relative m-auto max-w-7xl px-6" data-id="element-135">
        <motion.div className="flex flex-col items-center md:flex-row" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-136">
          <div className="md:max-w-44 md:border-r md:border-white/10 md:pr-6 mb-6 md:mb-0" data-id="element-137">
            <p className="text-center md:text-end text-sm text-white/70" data-id="element-138">
              Trusted By Leading Healthcare Organizations
            </p>
          </div>
          <div className="relative py-6 md:w-[calc(100%-11rem)] overflow-hidden" data-id="element-139">
            <div className="flex gap-16 animate-scroll items-center" data-id="element-140">
              {[...partners, ...partners].map((partner, index) => <motion.div key={index} className="flex-shrink-0" whileHover={{
              scale: 1.05
            }} transition={{
              duration: 0.2
            }} data-id="element-141">
                  <img src={partner.logo} alt={partner.name} className="h-12 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" data-id="element-142" />
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}